module.exports = __webpack_public_path__ + "static/img/15areaB_7.e7785ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/15areaB_7.png
// module id = 1138
// module chunks = 1